import i18n from '@/i18n'
// import ajingaPolicyManagement from './ajingaPolicyManagement/route'
// import defaultNotificationManagement from './notificationManagement/route'
import { TAB_CATEGORY } from '@/constant/permission'
import AsideMenuLayout from '../layout/asideMenuLayout.vue'

const routes = [
  // {
  //   name: 'systemNotificationManagement',
  //   path: '/manage-notification/',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_MANAGE_SYSTEM_NOTIFICATION',
  //     get title () {
  //       return i18n.t('admin.customer.systemNotificationManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.systemNotificationManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'jobPosterManagement',
  //   path: '/post-history-management/',
  //   component: null,
  //   meta: {
  //     get title () {
  //       return i18n.t('admin.customer.jobPosterManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.jobPosterManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'customerManagement',
  //   path: '/company-approval-management/',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_COMPANY_APPROVAL',
  //     get title () {
  //       return i18n.t('admin.customer.customerManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.customerManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'adsTierManagement',
  //   path: '/job-home-management/',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_SET_ADS_ORDER',
  //     get title () {
  //       return i18n.t('admin.customer.adsTierManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.adsTierManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'pointsManagement',
  //   path: '/referral/admin/points-management/',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_COMPANY_APPROVAL',
  //     get title () {
  //       return i18n.t('admin.customer.pointsManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.pointsManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'cashManagement',
  //   path: '/referral/admin/cash-management/',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_COMPANY_APPROVAL',
  //     get title () {
  //       return i18n.t('admin.customer.cashManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.cashManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'cashOutManagement',
  //   path: '/referral/admin/cashout-management/',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_COMPANY_APPROVAL',
  //     get title () {
  //       return i18n.t('admin.customer.cashOutManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.cashOutManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'serviceAccountManagement',
  //   path: '/admin2/add-admin/',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_COMPANY_APPROVAL',
  //     get title () {
  //       return i18n.t('admin.customer.serviceAccountManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.serviceAccountManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'uploadDataManagement',
  //   path: '/upload-data-management/',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_ADMIN_UPLOAD_DATA',
  //     get title () {
  //       return i18n.t('admin.customer.uploadDataManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.uploadDataManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'schoolManagement',
  //   path: '/school-tag-management/',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_ADMIN_SCHOOL_MANAGE',
  //     get title () {
  //       return i18n.t('admin.customer.schoolManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.schoolManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'superCandidateStatusManagement',
  //   path: '/candidate-status-list',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_ADMIN_STATUS_MANAGE',
  //     get title () {
  //       return i18n.t('admin.customer.candidateStatusManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.candidateStatusManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'majorManagement',
  //   path: '/major-tag-management/',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_ADMIN_MAJOR_MANAGE',
  //     get title () {
  //       return i18n.t('admin.customer.majorManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.majorManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'exportDataManagement',
  //   path: '/export-data-management/',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_ADMIN_EXPORT_DATA',
  //     get title () {
  //       return i18n.t('admin.customer.exportDataManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.exportDataManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'sourceChannelManagement',
  //   path: '/admin-source-channel/',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_SOURCING_CHANNEL_MANAGEMENT',
  //     get title () {
  //       return i18n.t('admin.customer.sourceChannelManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.sourceChannelManagement.menu')
  //       }
  //     }
  //   }
  // },
  // {
  //   name: 'superUserManagement',
  //   path: '/user-management/delete',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_VIEW_SUPER_PERMISSION',
  //     get title () {
  //       return i18n.t('admin.customer.userManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.customer.userManagement.menu')
  //       }
  //     }
  //   }
  // },
  // defaultNotificationManagement,
  // ajingaPolicyManagement,
  // {
  //   name: 'clientAdminJobBoardPointDashboard_old',
  //   path: '/v-admin/client-admin/job-post/record',
  //   redirect: '/v-admin/client-admin/job-board-point-dashboard',
  //   component: null,
  //   meta: {
  //     permission: ['PERM_COMPANY_APPROVAL'],
  //     titleI18nKey: 'admin.company.jobBoardPointDashboard.title.index',
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.company.jobBoardPointDashboard.menu.index')
  //       },
  //       hiddenInNewLayout: true
  //     }
  //   }
  // }
]

export default {
  name: 'clientAdminLayoutOld',
  path: '/client-admin-entrance',
  redirect: '/v-admin/client-admin/',
  component: AsideMenuLayout,
  meta: {
    isInclude: true,
    permission: TAB_CATEGORY.CLIENT_ADMIN,
    get title () {
      return i18n.t('admin.client.title')
    },
    tab: {
      get label () {
        return i18n.t('admin.client.tab')
      }
    }
  },
  children: routes
}
